<script lang="ts">

  import httpClient from "$lib/axios-client"
  import { Button } from "$lib/components/ui/button"
  import { Card, CardContent, CardHeader, CardTitle } from "$lib/components/ui/card"
  import type { _response } from "$lib/data/type/_response"
  import { createQuery } from "@tanstack/svelte-query"
  import ChevronRightIcon from "@lucide/svelte/icons/chevron-right"

  type Activity = {
    activity_count: number
    real_count: number
  }
  type Order = {
    order_count: number
    order_paid: number
  }

  let {
    prefix,
    date,
  }: {
    prefix: string
    date: string
  } = $props()

  const activityQuery = createQuery(() => ({
    queryKey: ["home-dash-activity", { date }],
    queryFn: async () => {
      return (
        await httpClient.get<_response<Activity>>(`/api/${prefix}/activity/dash`, {
          params: { date },
        })
      ).data.result
    },
  }))

  const orderQuery = createQuery(() => ({
    queryKey: ["home-dash-order", { date }],
    queryFn: async () => {
      return (
        await httpClient.get<_response<Order>>(`/api/${prefix}/order/dash`, {
          params: { date },
        })
      ).data.result
    },
  }))

</script>

<div class="mx-3 grid grid-cols-5 gap-2">
  {#if activityQuery.isFetching}
    <Card class="animate-pulse gap-0 rounded-md bg-foreground/10 py-0 shadow-none">
      <CardHeader class="px-2 pt-2 pb-0">
        <CardTitle class="text-xs font-normal leading-none opacity-0">-</CardTitle>
      </CardHeader>
      <CardContent class="px-2 pb-1 text-lg font-semibold tabular-nums tracking-tight opacity-0">-</CardContent>
    </Card>
    <Card class="animate-pulse gap-0 rounded-md bg-foreground/10 py-0 shadow-none">
      <CardHeader class="px-2 pt-2 pb-0">
        <CardTitle class="text-xs font-normal leading-none opacity-0">-</CardTitle>
      </CardHeader>
      <CardContent class="px-2 pb-1 text-lg font-semibold tabular-nums tracking-tight opacity-0">-</CardContent>
    </Card>
  {:else}
    <Card class="gap-0 rounded-md py-0 shadow-none">
      <CardHeader class="px-2 pt-2 pb-0">
        <CardTitle class="text-xs font-normal leading-none">Aktifitas</CardTitle>
      </CardHeader>
      <CardContent class="px-2 pb-1 text-lg font-semibold tabular-nums tracking-tight">
        {activityQuery.data?.activity_count ?? 0}
      </CardContent>
    </Card>
    <Card class="gap-0 rounded-md py-0 shadow-none">
      <CardHeader class="px-2 pt-2 pb-0">
        <CardTitle class="text-xs font-normal leading-none">Realisasi</CardTitle>
      </CardHeader>
      <CardContent class="px-2 pb-1 text-lg font-semibold tabular-nums tracking-tight">
        {activityQuery.data?.real_count ?? 0}
      </CardContent>
    </Card>
  {/if}

  {#if orderQuery.isFetching}
    <Card class="animate-pulse gap-0 rounded-md bg-foreground/10 py-0 shadow-none">
      <CardHeader class="px-2 pt-2 pb-0">
        <CardTitle class="text-xs font-normal leading-none opacity-0">-</CardTitle>
      </CardHeader>
      <CardContent class="px-2 pb-1 text-lg font-semibold tabular-nums tracking-tight opacity-0">-</CardContent>
    </Card>
    <Card class="col-span-2 animate-pulse gap-0 rounded-md bg-foreground/10 py-0 shadow-none">
      <CardHeader class="px-2 pt-2 pb-0">
        <CardTitle class="text-xs font-normal leading-none opacity-0">-</CardTitle>
      </CardHeader>
      <CardContent class="px-2 pb-1 text-base font-semibold opacity-0">-</CardContent>
    </Card>
  {:else}
    <Card class="gap-0 rounded-md py-0 shadow-none">
      <CardHeader class="px-2 pt-2 pb-0">
        <CardTitle class="text-xs font-normal leading-none">Order</CardTitle>
      </CardHeader>
      <CardContent class="px-2 pb-1 text-lg font-semibold tabular-nums tracking-tight">
        {orderQuery.data?.order_count ?? 0}
      </CardContent>
    </Card>
    <Card class="col-span-2 gap-0 rounded-md py-0 shadow-none">
      <CardHeader class="px-2 pt-2 pb-0">
        <CardTitle class="text-xs font-normal leading-none">Nilai Perolehan</CardTitle>
      </CardHeader>
      <CardContent class="px-2 pb-1 text-base font-semibold">
        Rp
        <span class="tabular-nums tracking-tight">{(orderQuery.data?.order_paid ?? 0).toLocaleString("en-US")}</span>
      </CardContent>
    </Card>
  {/if}

  <Button
    href={`/${prefix}/order-recap`}
    variant="outline"
    class="col-span-5 flex justify-between py-0 text-xs shadow-none">
    Rekap Hasil
    <ChevronRightIcon/>
  </Button>
</div>
